module.exports = __webpack_public_path__ + "shanz/static/media/abyalatest.ddaf9349.png";